





























import { Vue, Component } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import TabMenu from '@/components/common/TabMenu.vue';
@Component({
  components: { PageTitle, TabMenu, AdminIframe },
})
export default class CouponIssuePlanListIframe extends Vue {  
  private get remoteSrc() {
    const query = this.$route.query;
    const queryObject = { serviceType: 'PREMIUM', ...query };
    const queryString = new URLSearchParams(queryObject).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/promotion/basic/coupon?' + queryString;
  }
}
